import { FlowchartComponentDto } from './FlowchartComponentDto';
import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineActionDto } from './GuidelineActionDto';

export class FlowchartContainerDto extends FlowchartComponentDto {
  guidelineActionId?: string | null;
  guidelineAction?: GuidelineActionDto;
  elementType?: FlowchartElementType;
}
